import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
declare var $: any;
@Component({
  selector: 'app-draggablemodalhotline',
  templateUrl: './draggablemodalhotline.component.html',
  styleUrls: ['./draggablemodalhotline.component.scss']
})
export class DraggablemodalhotlineComponent implements OnInit {
  dateStateFilter:any
collection1=[{"date":"28/06/21","starttime":"5.30pm","technician":"sbs8" ,"dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1"},
{"date":"28/06/21","starttime":"5.30pm","technician":"kdhanasa" ,"dealercode": "GBRTEST11", "state":"Repair Qualification", rvc:"RVCCODE1" },
{"date":"28/06/21","starttime":"5.30pm","technician":"chinnat" ,"dealercode": "GBRTEST81", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"5.30pm","technician":"sbs8" ,"dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"5.30pm","technician":"sbs8" ,"dealercode": "GBRTEST12", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"5.30pm","technician":"sbs8" ,"dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"28/05/21","starttime":"5.30pm","technician": "chinnat","dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"28/05/21","starttime":"5.30pm","technician":"chinnat" ,"dealercode": "GBRTEST51", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/05/21","starttime":"4.30pm","technician": "kdhanasa","dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"6.30pm","technician":"kdhanasa" ,"dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"12.00am","technician":"chinnat" ,"dealercode": "GBRTEST31", "state":"Manual Diagnosis", rvc:"RVCCODE1" },
{"date":"22/06/21","starttime":"5.30pm","technician": "kdhanasa","dealercode": "GBRTEST11", "state":"Manual Diagnosis", rvc:"RVCCODE1" }]

  constructor(public activeModal: NgbActiveModal,private service: ApifirstService) { }
  config: any={itemsPerPage: 5,
  currentPage: 1,
  totalItems: 60}
  page:any
  
  collection:any = { count: 60, data: [{"id":0,"value":''}] }
  ngOnInit(): void {
    for (var i = 0; i < this.collection.count; i++) {
      this.collection.data.push(
        {
          "id": i + 1,
          "value": "items number " + (i + 1)
        }
      );
    $(document).ready(function(){
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
      handle: '.modal-header'
      });
    });
  }

  this.config = {
    itemsPerPage: 2,
    currentPage: 1,
    totalItems: this.collection.count
  };
}
q:any
pageChanged(event:any){
  this.config.currentPage = event;
  // this.config={itemsPerPage: 5,
  //   currentPage: 1,
  //   totalItems: this.collection.count}
}
onTableDataChange(event:any){
this.page=event
}

filterData(){
  this.dateStateFilter={date:'28/06/21',state:"Manual Diagnosis"}
}
}
